import React from 'react'
import { AlertIcon } from '../layout/Icons/AlertIcon'

export const PPCPBanner: React.FC = () => {
  return (
    <div className="yellowHeader">
      <div className="outerouter">
        <AlertIcon iconsSize="md" />
        <div className="myStuff">
          <strong>Our PayPal Champions page works best on desktop.</strong>
          <span>
            If something isn’t working on mobile, try switching to a desktop
            computer.
          </span>
        </div>
      </div>
    </div>
  )
}
